export default "__VITE_ASSET__D_w_cgyJ__"